import { message } from 'antd'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '@/hooks'
export const authority2path = {
  0: ['/', '/index', '/author', '/details', '/indexSecond', '/searchResult'],
  1: ['/', '/index', '/author', '/details', '/indexSecond', '/searchResult', '/analysis'],
  2: ['/', '/index', '/author', '/details', '/indexSecond', '/searchResult', '/analysis', '/admin']
}
export function AuthRouter({ children, path }) {
  const token = useAppSelector((state) => state.login.token)
  const authority = useAppSelector((state) => state.login.authority)

  if (token) {
    if (authority2path[authority].join('').includes(path)) return children
    else {
      message.error('您没有访问该页面的权限！')
      return <Navigate to='/index' />
    }
  } else {
    return <Navigate to='/' />
  }
}
